import type { PropsWithChildren } from 'react';

import { handleAnchorPropsByType } from './utils';

export enum ANCHOR_TYPES {
  callTelephone = 'callTelephone',
  openInNewTab = 'openInNewTab',
}

interface AnchorProps
  extends PropsWithChildren<{
    type: ANCHOR_TYPES;
    href: string;
  }> {}

export const Anchor = ({ type, href, children }: AnchorProps) => {
  const anchorProps = handleAnchorPropsByType(type, href);
  return <a {...anchorProps}>{children}</a>;
};
